// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__282wG","clinicsSelect":"TableHeading_clinicsSelect__1cjSv"};